export default "__VITE_ASSET__CaD6Mur0__"